<div class="sidebar-container" [class.collapsed]="!isOpen">
  <!-- Navigation Menu -->
  <nav class="sidebar-nav">
    <mat-list class="nav-list">
      <!-- Main Menu Items (Outside Settings) -->
      <div *ngFor="let item of mainMenuItems">
        <mat-list-item class="nav-item" [routerLink]="item.route" [class.active]="activeRoute.includes(item.route)">
          @if (item.isCustomIcon) {
            <mat-icon matListItemIcon [svgIcon]="item.icon"></mat-icon>
          } @else {
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          }
          <span matListItemTitle *ngIf="isOpen">{{ item.label }}</span>
        </mat-list-item>
      </div>

      <!-- Settings Section -->
      <div *ngIf="isOpen">
        <mat-expansion-panel
          class="settings-panel"
          [(expanded)]="isSettingsOpen"
          [class.active]="isSettingsRouteActive()"
          hideToggle="false"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="settings-icon">settings</mat-icon>
              <span class="settings-label" i18n>Settings</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Settings Submenu -->
          <div class="settings-content">
            <mat-list class="submenu-list">
              <div *ngFor="let item of settingsItems">
                <mat-list-item
                  class="submenu-item"
                  [routerLink]="item.route"
                  [class.active]="activeRoute.includes(item.route)"
                >
                  @if (item.isCustomIcon) {
                    <mat-icon matListItemIcon [svgIcon]="item.icon" class="submenu-icon"></mat-icon>
                  } @else {
                    <mat-icon matListItemIcon class="submenu-icon">{{ item.icon }}</mat-icon>
                  }
                  <span matListItemTitle>{{ item.label }}</span>
                </mat-list-item>
              </div>
            </mat-list>
          </div>
        </mat-expansion-panel>
      </div>

      <!-- Collapsed Settings Button -->
      <div *ngIf="!isOpen">
        <mat-list-item
          class="nav-item settings-collapsed"
          [class.active]="isSettingsRouteActive()"
          (click)="toggleSidebar(); isSettingsOpen = true"
          matTooltip="Settings"
          matTooltipPosition="right"
        >
          <mat-icon matListItemIcon>settings</mat-icon>
        </mat-list-item>
      </div>
    </mat-list>
  </nav>
</div>
